import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ButtonWrapper = styled.div`
  margin-left: auto;

  ul {
    justify-content: flex-end;
  }
`

export const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: -${Spacing.S16};
  margin-bottom: -${Spacing.S16};
`
